module.exports = __webpack_public_path__ + "img/staff-availability.7005a6a7.svg";